import React from 'react';

export const About = () => (
  <section id="about" className="py-20 px-4 bg-black" data-testid="about-section">
    <div className="container mx-auto">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-bold mb-8 text-center">
          About <span className="text-amber-500">Derby</span>
        </h2>
        <div className="space-y-6 text-lg text-gray-300 leading-relaxed">
          <p>
            DERBY is a trusted electrical brand owned by Meghdoot Enterprises, a firm established in 1993 by Mr. Shyamlal Kukreja in Kanpur. Built on decades of experience in electrical wires, cables, switches, accessories, and appliances, DERBY represents consistent quality, reliable performance, and a commitment to long-term value. Since 2014, with the second generation joining the business, the brand has expanded its product portfolio through carefully selected manufacturing partners, ensuring dependable standards across every category.
          </p>
          <p>
            Over the past two years, DERBY has undergone a focused revival, strengthening its presence across Uttar Pradesh and parts of Madhya Pradesh through a dedicated dealer network. With a clear strategy, disciplined product development, and a growing market footprint, DERBY continues its transition from a regional player to a modern, aspirational electrical brand designed for today's homes and businesses.
          </p>
        </div>
      </div>
    </div>
  </section>
);
